import { useEffect } from "react";
import "./ServicePage.css";
import Breadcrumb from "../Breadcrumb";
import Section from "../Section";
import TestimonialSection from "../Section/TestimonialSection";
import { pageTitle } from "../../helpers/PageTitle";
import FranchiseForm from "./FranchiseForm";

import {
  FaSolarPanel,
  FaIndustry,
  FaBroom,
  FaChargingStation,
  FaProjectDiagram,
  FaHandshake,
  FaShieldAlt,
  FaLeaf,
  FaHeadset,
  FaTachometerAlt,
  FaHome,
  FaWarehouse,
  FaSun,
  FaPlug,
  FaUserCog,
  FaChartLine,
  FaCertificate,
  FaCogs,
  FaMobileAlt,
  FaMapMarkerAlt,
  FaClock,
  FaUsers,
  FaAward,
  FaRocket
} from "react-icons/fa";

export default function ServicesPage() {
  pageTitle("Our Solar Services");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  const testimonialData = [
    {
      imgUrl: "/images/avatar_1.png",
      rating: "4.8",
      desc: "Riyansh Solar Power executed our factory's 100kW solar project flawlessly. Excellent team support and quick installation!",
      name: "Rohit Mehta",
      designation: "Factory Owner, Gujarat",
    },
    {
      imgUrl: "/images/avatar_2.png",
      rating: "5.0",
      desc: "Very satisfied with their solar AMC services. Our energy output has increased by 20% after regular maintenance.",
      name: "Sneha Sharma",
      designation: "Residential Customer, Pune",
    },
    {
      imgUrl: "/images/avatar_3.png",
      rating: "4.9",
      desc: "Professional EV charging setup for our apartment complex. Easy to use and very efficient.",
      name: "Karan Patel",
      designation: "Housing Society Manager, Mumbai",
    },
    {
      imgUrl: "/images/avatar_4.png",
      rating: "4.7",
      desc: "The best franchise opportunity I've ever invested in! Complete business support and strong brand presence.",
      name: "Ankit Verma",
      designation: "Solar Franchise Partner, Delhi",
    },
  ];

  const serviceData = [
    {
      icon: <FaSolarPanel />,
      title: "Solar EPC & Project Execution",
      subTitle: "End-to-end solar engineering, procurement, and construction for seamless project completion.",
      features: ["Custom Design", "Quality Assurance", "Timely Delivery"],
      gradient: "from-blue-500 to-cyan-400",
      serviceIcons: [<FaCogs />, <FaCertificate />, <FaClock />]
    },
    {
      icon: <FaIndustry />,
      title: "Commercial & Industrial Solar Solutions",
      subTitle: "Cost-effective solar power systems designed for factories, warehouses, and institutions.",
      features: ["High Efficiency", "Cost Savings", "ROI Analysis"],
      gradient: "from-green-500 to-emerald-400",
      serviceIcons: [<FaWarehouse />, <FaChartLine />, <FaTachometerAlt />]
    },
    {
      icon: <FaBroom />,
      title: "Solar Panel Cleaning & AMC Services",
      subTitle: "Professional maintenance and cleaning to maximize energy efficiency and system lifespan.",
      features: ["Regular Maintenance", "Performance Monitoring", "24/7 Support"],
      gradient: "from-orange-500 to-amber-400",
      serviceIcons: [<FaShieldAlt />, <FaHeadset />, <FaTachometerAlt />]
    },
    {
      icon: <FaChargingStation />,
      title: "E-Mobility & EV Charging Solutions",
      subTitle: "Smart and sustainable EV charging infrastructure for homes, businesses, and public stations.",
      features: ["Fast Charging", "Smart Grid Integration", "Mobile App Control"],
      gradient: "from-purple-500 to-pink-400",
      serviceIcons: [<FaPlug />, <FaMobileAlt />, <FaHome />]
    },
    {
      icon: <FaProjectDiagram />,
      title: "Net Metering, Commissioning & Consulting",
      subTitle: "Expert support for solar grid connectivity, documentation, and government approvals.",
      features: ["Govt. Subsidy Support", "Documentation", "Technical Consulting"],
      gradient: "from-indigo-500 to-blue-400",
      serviceIcons: [<FaUserCog />, <FaCertificate />, <FaChartLine />]
    },
    {
      icon: <FaHandshake />,
      title: "Solar Franchise & Business Opportunities",
      subTitle: "Join India's fastest-growing solar franchise network with minimal investment and high returns.",
      features: ["Training Program", "Marketing Support", "High Profit Margin"],
      gradient: "from-red-500 to-orange-400",
      serviceIcons: [<FaUsers />, <FaRocket />, <FaAward />]
    },
  ];

  const statsData = [
    { number: "500+", label: "Projects Completed", icon: <FaProjectDiagram /> },
    { number: "5+", label: "Years Experience", icon: <FaCertificate /> },
    { number: "95%", label: "Customer Satisfaction", icon: <FaUsers /> },
    { number: "50+", label: "Cities Covered", icon: <FaMapMarkerAlt /> }
  ];

  const additionalServices = [
    { icon: <FaHome />, title: "Residential Solar Systems", desc: "Complete home solar solutions with net metering" },
    { icon: <FaWarehouse />, title: "Industrial Solar Plants", desc: "Large-scale solar power for industries" },
    { icon: <FaSun />, title: "Solar Water Heating", desc: "Efficient solar thermal systems for hot water" },
    { icon: <FaPlug />, title: "Off-Grid Solutions", desc: "Independent power systems for remote areas" },
  ];

  return (
    <>
      <Breadcrumb 
        title="Our Solar Solutions" 
        bgUrl="/images/solar_banner.jpeg" 
      />

      {/* Hero Section */}
      <section className="services-hero">
        <div className="services-hero-content">
          <div className="hero-text">
            <div className="badge">
              <FaLeaf className="badge-icon" />
              Sustainable Energy Solutions
            </div>
            <h1>
              Powering India with <span>Smart Solar Solutions</span>
            </h1>
            <p>
              From EPC to EV charging, Riyansh Solar Power Plus Pvt. Ltd. delivers 
              complete renewable energy solutions designed for sustainability and profitability.
            </p>
            <div className="hero-stats">
              {statsData.map((stat, index) => (
                <div key={index} className="stat-item">
                  <div className="stat-icon">{stat.icon}</div>
                  <div className="stat-number">{stat.number}</div>
                  <div className="stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="hero-visual">
            <div className="floating-card card-1">
              <FaSolarPanel />
              <span>EPC Services</span>
            </div>
            <div className="floating-card card-2">
              <FaChargingStation />
              <span>EV Charging</span>
            </div>
            <div className="floating-card card-3">
              <FaShieldAlt />
              <span>AMC Services</span>
            </div>
            <div className="floating-card card-4">
              <FaHandshake />
              <span>Franchise</span>
            </div>
            <div className="main-visual">
              <img 
                src="https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2072&q=80" 
                alt="Solar Panels" 
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="services-main">
        <div className="services-container">
          <div className="services-header">
            <h5 className="sub-heading">Our Services</h5>
            <h2 className="main-heading">
              Comprehensive Solar <span>Energy Solutions</span>
            </h2>
            <p className="desc">
              We provide end-to-end solar energy services tailored to meet your specific needs, 
              ensuring maximum efficiency and return on investment.
            </p>
          </div>

          <div className="service-grid">
            {serviceData.map((service, index) => (
              <div className="service-card" key={index}>
                <div className={`service-icon-wrapper bg-gradient-${service.gradient.split(' ')[1]}`}>
                  <div className="service-icon">
                    {service.icon}
                  </div>
                </div>
                <h3>{service.title}</h3>
                <p>{service.subTitle}</p>
                
                <div className="service-features-icons">
                  {service.features.map((feature, idx) => (
                    <div key={idx} className="feature-item">
                      <div className="feature-icon">
                        {service.serviceIcons[idx]}
                      </div>
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
                
                <div className="service-footer">
                  <div className="service-badges">
                    <span className="badge-premium">
                      <FaAward /> Premium
                    </span>
                    <span className="badge-supported">
                      <FaHeadset /> 24/7 Support
                    </span>
                  </div>
                </div>
                
                <div className="service-glow"></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Services */}
      <section className="additional-services">
        <div className="services-container">
          <div className="services-header">
            <h5 className="sub-heading">More Services</h5>
            <h2 className="main-heading">
              Extended Solar <span>Solutions</span>
            </h2>
          </div>
          
          <div className="additional-grid">
            {additionalServices.map((service, index) => (
              <div key={index} className="additional-card">
                <div className="additional-icon">
                  {service.icon}
                </div>
                <h4>{service.title}</h4>
                <p>{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* Testimonial Section */}
      {/* <Section
        pt="140"
        ptLg="75"
        pb="135"
        pbLg="75"
        style={{ backgroundImage: `url("/images/solar_testimonial_bg.jpeg")` }}
      >
        <TestimonialSection
          sectionTitleUp="Testimonials"
          sectionTitle="What Our Clients Say"
          sectionSubTitle="Delivering excellence through solar technology, expert guidance, and reliable service."
          data={testimonialData}
        />
      </Section> */}

      <FranchiseForm />
    </>
  );
}